import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { qualificationApi } from '../redux/supplier-qualifications.slice';

export function useSupplierQualification(id: string) {
  const { entity: qualification } = useEntityIdSelector(qualificationApi, id);
  return { qualification };
}
